'use client';
import { withFullPath } from '@src/common/path-convert';
import cn from 'classnames';
import Image from 'next/image';

type Props = {
    src: string;
    classNames?: string;
    width?: number;
    height?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onclickFun?: (e: any) => void;
};

/** 懒加载-Nextjs Image */
const ImgLazy = (props: Props) => {
    const { classNames, width, height, src = '', onclickFun } = props;

    return (
        <div className='relative' style={{ width: `${width}px`, height: `${height}px` }}>
            {src && (
                <Image
                    className={cn(classNames, 'object-cover')}
                    loading='lazy'
                    sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
                    fill
                    onClick={onclickFun}
                    src={withFullPath(src ?? '')}
                    alt=''
                />
            )}
        </div>
    );
};

export default ImgLazy;
